import { frames, icons, useMediaQuery } from "../../Styles/index"
import { useTranslation } from "react-i18next"
import "../../Translations/index"
import { ButtonList } from "../../Components"
import { NavigationFunction, Pages } from "../Routers/CloudPanel/globalMenu_Router"
import { useNavigate } from "react-router"
import { StyleObject } from "styletron-react"
import { useMemo } from "react"
import { ButtonTypes, ListStyle_Types } from "../../Definitions"

interface GlobalMenu_Props {
  overrides?:{
      gridArea?: string
  }
}

export default function GlobalMenu({overrides}:GlobalMenu_Props) {
  const navigator = useNavigate()
  const {t} = useTranslation()

  const groupMenu2columns = useMediaQuery(`(max-width: 454px), (min-width: 1000px)`)
  const groupMenu3columns = useMediaQuery(`(min-width: 455px) and (max-width: 590px)`)
  
  const BtnFunc_Router = (btn_Index:number) => {
    switch (btn_Index) {
      case 0: // Navigate Def
        NavigationFunction(navigator, Pages.dashboard)
        break
      case 1: // Navigate Def
        NavigationFunction(navigator, Pages.kpi)
        break
      case 2:
        NavigationFunction(navigator, Pages.feedCurves)
        break
      case 3:
        NavigationFunction(navigator, Pages.silos)
        break
      case 4:
        NavigationFunction(navigator, Pages.animals)
        break
      case 5:
        NavigationFunction(navigator, Pages.reports)
        break
      case 6:
        NavigationFunction(navigator, Pages.logbook)
        break
      case 7:
        NavigationFunction(navigator, Pages.globalSettings)
        break
      default:
        alert("Error ???")
    }
  }

  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
        {} as StyleObject, //default stlye
        overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {}
    )
  },[overrides])

  return (
    <frames.GlobalMenu $style={_Root}>
      <div style={{width: groupMenu2columns ? "265px" : groupMenu3columns ? "400px" : "535px"}}>
        <ButtonList
          contents={[t("globalMenu.dashboard"), t("globalMenu.kpi"), t("globalMenu.feedCurves"), t("globalMenu.silos"), t("globalMenu.animals"), t("globalMenu.reports"), t("globalMenu.logBook"), t("globalMenu.globalSettings")]}
          onClick={(e) => BtnFunc_Router(e)}
          buttonType={ButtonTypes.globalMenuButton}
          hasActiveLoad={true}
          listOverrides={{
            useNavigationControl: "global_index",
            listStyle: ListStyle_Types.group
          }}
          startEnhancers={[
            icons.dashboard, icons.kpi, icons.feedCurves, icons.silos, icons.animals, icons.reports, icons.logBook, icons.globalSettings
          ]}
          disabled={[true, false, false, true, false, false, true, false]}
        />
      </div>
    </frames.GlobalMenu>
  )

}
